export const assetsPath = '../../assets'
